var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-content-center"},[(_vm.url)?_c('a',{staticClass:"btn btn-dark my-6 px-4 py-3",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm._f("translate")('Go to exam panel')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }